import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TimeLabel = styled.span`
  ${typographyV2.bodySm};
`;

export const AsOfLastCloseLabel = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const MarketClosedLabel = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const MarketOpenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.35em;
`;

export const MarketOpenLabel = styled.span`
  ${typographyV2.bodySm};
  color: var(--viz-bullish);
`;

export const LiveDataLabel = styled.span`
  ${typographyV2.bodySm};
`;
